import React from "react";

const FetchError = ({ message }) => (
  <div>
    <p>{`Could not fetch library. ${message}`}</p>
  </div>
);

export default FetchError;
